import {
  CustomStylesType,
  TemplateProvider,
  Text,
} from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Grid, Stack } from '@mantine/core'

import CarouselCard from 'components/atoms/CarouselCardV2/'
import { Container } from 'components/atoms/container'
import GroupItems from 'components/atoms/groupItems'
import { SpotlightCustomizeBlockSession } from 'interfaces/types'

import useStyles from './index.styles'
import { Item } from './Item'

type Props = {
  data: SpotlightCustomizeBlockSession
} & BoxProps

export const CustomizedBlock = ({
  data,
  styles,
  classNames,
  className,
  ...restProps
}: Props) => {
  const { listing = [], title, description, backgroundColor } = data
  const listingLength = listing.length
  const { classes, cx } = useStyles(
    { backgroundColor },
    {
      name: 'CustomizedBlock',
      styles,
      classNames,
    },
  )
  return listingLength > 0 ? (
    <TemplateProvider variant={CustomStylesType.LEADGEN}>
      <Stack {...restProps} className={cx(classes.root, className)}>
        <Container className={classes.inner}>
          {(title || description) && (
            <Stack spacing={8} className={classes.header}>
              {title && (
                <Text size="h2" weight="bold">
                  {title}
                </Text>
              )}
              {description && <Text size="p2">{description}</Text>}
            </Stack>
          )}
          <GroupItems
            breakpoints={{
              base: {
                itemsPerGroup: listingLength,
                GroupWrapper: (children) => (
                  <CarouselCard
                    slideSize={'90%'}
                    slideGap={8}
                    styles={{
                      root: {
                        marginLeft: -16,
                        marginRight: -16,
                      },
                      viewport: {
                        paddingLeft: 16,
                        paddingRight: 16,
                      },
                    }}
                  >
                    <CarouselCard.Body>{children}</CarouselCard.Body>
                    <Box>
                      <CarouselCard.Progress
                        styles={(theme) => ({
                          root: {
                            [theme.fn.smallerThan('md')]: {
                              display: 'block',
                              height: 6,
                              borderRadius: 4,
                              backgroundColor: theme.colors.neutral[1],
                            },
                          },
                          bar: {
                            backgroundColor: theme.colors.gray[3],
                            border: `1px solid ${theme.colors.neutral[1]}`,
                          },
                        })}
                      />
                    </Box>
                  </CarouselCard>
                ),
                ItemWrapper: (children) => (
                  <CarouselCard.Slide>
                    <Box sx={{ padding: `0 4px 24px`, height: '100%' }}>
                      {children}
                    </Box>
                  </CarouselCard.Slide>
                ),
              },
              md: {
                itemsPerGroup: listingLength,
                GroupWrapper: (children) => <Grid gutter={24}>{children}</Grid>,
                ItemWrapper: (children) => (
                  <Grid.Col span={12 / Math.min(listingLength, 4)}>
                    {children}
                  </Grid.Col>
                ),
              },
            }}
            items={listing.map((i, idx) => (
              <Item
                size={listingLength < 4 ? 'md' : 'sm'}
                className="customize-item"
                key={String(idx)}
                {...i}
              />
            ))}
          />
        </Container>
      </Stack>
    </TemplateProvider>
  ) : null
}
